import React from 'react';
import {
    NavLink,
    Redirect,
    Route,
    Switch
} from 'react-router-dom';
import { connect } from 'react-redux';

import { getOrdersFindCounts } from './../store/ordersFind/selectors';

import Nav from './../components/Nav';
import Icon from './../components/Icon';

import FindOrdersAllPage from './FindOrdersAllPage';
import FindOrdersSavedPage from './FindOrdersSavedPage';

const FindOrdersPage = props => {
    const { match, allCount, favoriteCount } = props;
    return (
        <div>
            <Nav sub>
                <NavLink to={`${match.url}/all`}>
                    All Orders
                    {!allCount ? '' : ` (${allCount})`}
                </NavLink>
                <NavLink to={`${match.url}/saved`}>
                    <Icon className="svg-icon" iconName="star" />
                    Saved Orders
                    {!favoriteCount ? '' : ` (${favoriteCount})`}
                </NavLink>
            </Nav>
            <Switch>
                <Route path={`${match.url}/all/:orderNumber`} component={FindOrdersAllPage} />
                <Route path={`${match.url}/all`} component={FindOrdersAllPage} />
                <Route path={`${match.url}/saved/:orderNumber`} component={FindOrdersSavedPage} />
                <Route path={`${match.url}/saved`} component={FindOrdersSavedPage} />
                <Redirect from={match.url} exact to={{ pathname: `${match.url}/all`, search: window.location.search }} push={false} />
            </Switch>
        </div>
    );
};

const mapStateToProps = (state, ownProps) => {
    const counts = getOrdersFindCounts(state);
    return {
        allCount: counts.all,
        favoriteCount: counts.favorite,
    };
};

export default connect(mapStateToProps)(FindOrdersPage);


// WEBPACK FOOTER //
// ./src/pages/FindOrdersPage.js